import { t } from "../../../../../../../utils/i18n";
import React from "react";
import DisplayFile from "./DisplayFile";
interface Props {
  data: any;
  onClickEdit: (e: any, step: string) => void;
}

const IdentificationDetails: React.FC<Props> = ({ data, onClickEdit }) => (
  <div className="card-inner-container">
    <h6 className="card-sub-title">{t("cards.request_form.identification_details")}</h6>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.date_of_birth")}</label>
      <div className="col-12 col-md-9">
        <span>{data.dateOfBirth}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.place_of_birth_2")}</label>
      <div className="col-12 col-md-9">
        <span>{data.placeOfBirth}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.passport_number")}</label>
      <div className="col-12 col-md-9">
        <span>{data.passportNumber}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label">{t("cards.request_form.passport_issued_date")}</label>
      <div className="col-12 col-md-9">
        <span>{data.passportIssuedDate}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.passport_expiry_date")}</label>
      <div className="col-12 col-md-9">
        <span>{data.passportExpiryDate}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.passport_bio_page")}</label>
      <div className="col-12 col-md-9">
        <DisplayFile file={data.passportBioPage} />
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.selfie_with_passport_bio_page")}
      </label>
      <div className="col-12 col-md-9">
        <DisplayFile file={data.passportWithSelfie} />
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.digital_signature")}</label>
      <div className="col-12 col-md-9">
        <DisplayFile file={data.digitalSignature} />
      </div>
    </div>
    <div className="ml-auto">
      <a
        className="btn btn-purple"
        href="#"
        onClick={(e) => onClickEdit(e, "identification")}
      >
        {t("cards.request_form.edit")} <i className="fa fa-pen"></i>
      </a>
    </div>
  </div>
);

export default IdentificationDetails;
